import { render, staticRenderFns } from "./DropdownWrapper.vue?vue&type=template&id=1efca3f5&"
import script from "./DropdownWrapper.vue?vue&type=script&lang=js&"
export * from "./DropdownWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports